import { useEffect, useState } from 'react';
import Modal from 'react-modal';

import ErrorView from '@components/ErrorView';
import Song from '@data/interfaces/song.interface';
import closeIcon from 'url:@icon/close.svg';

import './index.scss';

export default function RemoveSongModal(props: {
  isOpen: boolean;
  song: Song | null;
  close: () => void;
  onAfterClose?: () => void;
  onConfirm: (song: Song) => Promise<{ success: boolean; title: string; message: string; }>;
}) {
  const [isRemoving, setIsRemoving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [renderedSong, setRenderedSong] = useState<Song | null>(props.song);

  useEffect(() => {
    if (props.isOpen && props.song) {
      setRenderedSong(props.song);
    }
  }, [props.isOpen, props.song]);

  if (!renderedSong) {
    return null;
  }

  const removeSong = async () => {
    setIsRemoving(true);
    setError(null);

    try {
      const result = await props.onConfirm(renderedSong);
      if (!result.success) {
        setError(result.message);
        setIsRemoving(false);
        return;
      }

      props.close();
    } finally {
      setIsRemoving(false);
    }
  };

  return <Modal
    id='remove-song-modal'
    isOpen={props.isOpen}
    closeTimeoutMS={200}
    className='modal remove-song-modal-shell'
    onAfterClose={() => {
      setError(null);
      setIsRemoving(false);
      setRenderedSong(null);
      props.onAfterClose?.();
    }}>
    <div className='remove-song-modal-content'>
      <div className='header'>
        <a aria-disabled={isRemoving}
          className={isRemoving ? 'close disabled' : 'close'}
          href='#'
          onClick={(e) => {
            e.preventDefault();

            if (isRemoving) {
              return;
            }

            props.close();
          }}>
          <img className='icon' src={closeIcon} alt='Close icon' />
        </a>

        <h3 className='title'>Remove Song</h3>
      </div>

      {error ? <div className='body'>
        <ErrorView error={error} showButton={false} />
      </div> : <div className='body'>
        <p>Remove <strong>{renderedSong.attributes.title}</strong> from this playlist?</p>

        <div className='spacer' />

        <button
          type='button'
          className='remove-song-button'
          disabled={isRemoving}
          onClick={() => {
            void removeSong();
          }}>
          Remove Song
        </button>
      </div>}
    </div>
  </Modal>;
}
